import React, { Component } from "react";
import PropTypes from "prop-types";
import ViewCategories from "./subcategories/view";
import * as qs from "query-string";
import { withRouter, Link } from "react-router-dom";
import Pagination from "react-paginating";
import { createBrowserHistory } from "history";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";

import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  InputGroup,
  FormControl,
  Glyphicon,
  Modal,
  ControlLabel,
  DropdownButton,
  MenuItem,
  ButtonGroup,
} from "react-bootstrap";
import { compose } from "redux";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import Toggle from "react-bootstrap-toggle";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
let isLoading = "false";
class Categories extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_CATEGORY',
      catList: [],
      no: 0,
      activePage: 1,
      msg_status: "hide",
      path: ["Home", "Manage Categories"],
      links:["home", "categories"],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      show: "false",
      categoryStatus: {},
      catNameSortIcon: "",
      catTypeSortIcon: "",
      direction: "",
      orderBy: "",
      french_catName: "",
      multi_lang: 'no',
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    const {
      actions: { getAllCategory }
    } = this.props;
    getAllCategory({ orderBy: orderBy, direction: direction,limit:this.state.limit });
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    const {
      actions: { getAllCategory }
    } = this.props;
    if (searchString.length > 0) {
      getAllCategory({ search: searchString });
    } else {
      getAllCategory({ page: this.state.currentPage,limit:this.state.limit });
    }

    this.setState({ searchString: searchString });
  };
  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    this.handlePageChange(this.state.activePage);
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.catList !== nextProps.catList) {
      let categoryStatusObject = new Object();

      let setPageCount =
        nextProps.catList.data.total / nextProps.catList.data.per_page;
      this.setState({
        catList: nextProps.catList.data.data,
        totalRecords: nextProps.catList.data.total,
        perPage: nextProps.catList.data.per_page,
        pageCount: setPageCount
      });
      if (nextProps.catList.data.data) {
        nextProps.catList.data.data.map((cat, index) => {
          const id = cat.catID;
          if (cat.status == "Active") {
            categoryStatusObject[id] = true;
          } else if (cat.status === "Inactive") {
            categoryStatusObject[id] = false;
          }
        });
      }
      this.setState({ categoryStatus: categoryStatusObject });
    }
    if (
      this.props.catStatus !== nextProps.catStatus &&
      !isEmpty(nextProps.catStatus)
    ) {
      if (nextProps.catStatus) {
        isLoading = "false";
        const {
          actions: { clearAlerts }
        } = this.props;
        clearAlerts();
        this.handleShow();
        const {
          actions: { renderAlerts }
        } = this.props;
        renderAlerts("success", nextProps.catStatus.message);

        const {
          actions: { getAllCategory }
        } = this.props;
        getAllCategory({ page: this.state.activePage,limit:this.state.limit });
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
    if (this.props.deleteStatus !== nextProps.deleteStatus) {
      const {
        actions: { clearAlerts }
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts }
      } = this.props;
      renderAlerts("success", nextProps.deleteStatus.message);

      const {
        actions: { getAllCategory }
      } = this.props;
      getAllCategory({ page: this.state.activePage,limit:this.state.limit });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        const {
          actions: { clearAlerts }
        } = this.props;
        clearAlerts();
        this.handleShow();
        const {
          actions: { renderAlerts }
        } = this.props;
        renderAlerts("warning", nextProps.updatedMerchant.message);
      }
    }
  }

  changeStatus = (catID, status) => {
    this.handleShow();
    isLoading = "true";
    let updateStatus = "";
    if (status === "Active") {
      updateStatus = "Inactive";
    } else if (status === "Inactive") {
      updateStatus = "Active";
    }
    const {
      actions: { statusCategory }
    } = this.props;
    statusCategory(catID, updateStatus);
  };

  handleClick = e => {
    e.preventDefault();
    const { history } = this.props;
    this.context.router.history.push("/categories/addCategory");
  };

  handlePageChange = page => {
    this.setState({
      activePage: page
    });
    const {
      actions: { getAllCategory }
    } = this.props;
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      getAllCategory({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit:this.state.limit
      });
    } else if (this.state.searchString !== "") {
      getAllCategory({ page: page, search: this.state.searchString, limit:this.state.limit });
    } else {
      getAllCategory({ page: page, limit:this.state.limit });
    }
  };

  handleDelete = catID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(catID);
          this.handleShow();
        })
      ]
    });
  };

  confirmDelete = catID => {
    const {
      actions: { deleteCategory }
    } = this.props;
    deleteCategory(catID);
    const {
      actions: { getAllCategory }
    } = this.props;
    getAllCategory({ page: this.state.activePage,limit:this.state.limit });
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;

    let contentRow;
    if (!isEmpty(this.state.catList) && !isEmpty(this.state.categoryStatus)) {
      contentRow = this.state.catList.map((cat, index) => (
        <tr key={cat.catID}>
          <td>{cat.catName}</td>
          {(this.state.multi_lang == "yes") &&
          <td>{cat.french_catName}</td>
          }
          <td>{cat.catType}</td>
          {aclUtil.checkACL('STATUS_CATEGORY') ? (<td>
            <Toggle
              on={"Active"}
              off={"Inactive"}
              size="lg"
              responsive="true"
              offstyle="default"
              onstyle="success"
              height="30px"
              width="100px"
              active={this.state.categoryStatus[cat.catID]}
              onClick={this.changeStatus.bind(this, cat.catID, cat.status)}
            />
          </td>) :("")}
          <td>
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                {aclUtil.checkACL('VIEW_CATEGORY') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/viewcategories/${cat.catID}`)}><i className="glyphicon glyphicon-eye-open"></i> View</MenuItem>) : ("")}
                {aclUtil.checkACL('EDIT_CATEGORY') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addCategory/${cat.catID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>) : ("")}
                {aclUtil.checkACL('DELETE_CATEGORY') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, cat.catID)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>) : ("")}
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }
    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Category List</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              {aclUtil.checkACL('ADD_CATEGORY') ? (
              <div className="row">
                <div className="col-lg-12 text-right">
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/categories/addCategory")}
                  >
                    + Add Category
                  </Button>
                </div>
              </div>) : ("")}
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="clearfix" />
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("catName")}>
                          {" "}
                          Category Name{" "}
                          <span
                            className={this.state.catNameSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        {(this.state.multi_lang == "yes") &&
                          <th >
                            {" "}
                            Category Name (Canadian French){" "}
                          </th>
                        }
                        <th onClick={this.handleSort("catType")}>
                          {" "}
                          Category Type<span
                            className={this.state.catTypeSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        {aclUtil.checkACL('STATUS_CATEGORY') ? (<th>Status</th>) :("")}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{contentRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(withRouter)(Categories);



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/Categories.js